var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"section"},[_c('title-bar',{attrs:{"title":"Capacitaciones"}}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"has-text-centered"},[_vm._v(" No hay información ")])])])
}]

export { render, staticRenderFns }